import * as React from "react";
import { Component } from "react";
import { Button, ButtonGroup } from "reactstrap";
import { Query, QueryMode } from "../api/Query";

interface GlmQueryProps {
  onChange(query: Query): void;

  query: Query;
}

interface GlmQueryState {
  q: string;
}

export default class GlmQuery extends Component<GlmQueryProps, GlmQueryState> {
  constructor(props: GlmQueryProps) {
    super(props);
    this.state = { q: props.query.q };
  }

  private onQChange(value: string) {
    const copy = { ...this.props.query };
    copy.q = value;
    this.setState({ q: value });
    this.props.onChange(copy);
  }

  private onModeChange(mode: QueryMode) {
    const copy = { ...this.props.query };
    copy.mode = mode;
    this.props.onChange(copy);
  }

  private queryModeArray() {
    return [QueryMode.GLM, QueryMode.MONGO];
  }

  render() {
    return (
      <>
        <textarea
          rows={1}
          className="form-control"
          value={this.state.q}
          onChange={(evt) => this.onQChange(evt.target.value)}
          placeholder={this.props.query.mode + " query..."}
        />
        <ButtonGroup vertical>
          {this.queryModeArray().map((mode) => (
            <Button
              key={mode}
              title={"Query mode : " + mode}
              active={this.props.query.mode == mode}
              onClick={() => this.onModeChange(mode)}
            >
              <span className="text-capitalize">{mode}</span>
            </Button>
          ))}
        </ButtonGroup>
      </>
    );
  }
}
